import { Box } from "@mui/material";
import React from "react";

interface UnreadSeparatorProps {
  count: number;
}

const UnreadSeparator: React.FC<UnreadSeparatorProps> = ({ count }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        my: 2,
        width: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.05)",
        padding: "6px 0",
      }}
    >
      <Box
        sx={{
          background: "#fff",
          color: "#3b4a54",
          borderRadius: "20px",
          px: 3,
          py: 0.5,
          fontWeight: 600,
          fontSize: 14,
          textTransform: "none",
          boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
          textAlign: "center",
          userSelect: "none",
          minWidth: 150,
          minHeight: 20,
          lineHeight: 1.2,
          letterSpacing: 0,
        }}
      >
        {count === 1 ? "1 mensagem não lida" : `${count} mensagens não lidas`}
      </Box>
    </Box>
  );
};

export default UnreadSeparator;
